import React from 'react';
import {useHistory} from 'react-router-dom';
import {useTranslation, Trans} from 'react-i18next';
import {useComputedReservationDetails} from '../../../context/computedReservationDetails';
import {getNewGuestUrl} from '../../../utils/checkin';
import guestRegisteredImg from 'assets/img/status-guest-registered-icon.png';
import StyledIcon from 'components/acommon/StyledIcon';
import Button from 'components/Button';
import {
  StyledModalGuestRegistered,
  ModalSubtitle,
  ModalHeader,
  Row,
  ModalBody,
  ModalTitleText,
} from './styled';

type ModalTypes = {
  name: string;
  setModalGuestRegisteredOpen: any;
  finishCheckin?: any;
  resetForm?: () => void;
};

function ModalGuestRegistered({
  name,
  finishCheckin,
  setModalGuestRegisteredOpen,
}: ModalTypes) {
  const history = useHistory();
  const {t} = useTranslation();
  const reservationDetails = useComputedReservationDetails();
  const anotherGuestLabel = reservationDetails.isAllGuestsRegistered
    ? t('all_guests_registered')
    : t('register_another_guest_lowwer_case');

  const handleNextButton = () => {
    setModalGuestRegisteredOpen(false);
    finishCheckin();
  };

  const handleRegisterAnotherGuest = async () => {
    setModalGuestRegisteredOpen(false);

    const {url, state} = getNewGuestUrl(reservationDetails);
    history.push(url, state);
  };

  return (
    <StyledModalGuestRegistered>
      <ModalHeader>
        <Row>
          <img
            src={guestRegisteredImg}
            alt="Guest registered!"
            width={110}
            height={110}
          />
        </Row>
        <Row className="modalTitle">
          <StyledIcon name="successIcon" size="32px" color="white" />
          <ModalTitleText>{t('guest_registered')}</ModalTitleText>
        </Row>
      </ModalHeader>
      <ModalBody>
        <Row>
          <ModalSubtitle>
            <Trans i18nKey="guest_registered_modal_description" values={{name}}>
              <b>{name}</b> has been successfully registered. Would you like to go to the
              next step or to register more guests right now?
            </Trans>
          </ModalSubtitle>
        </Row>
        <Row style={{padding: '40px 0'}}>
          <Button label={t('next')} iconRight="arrowNext" onClick={handleNextButton} />
        </Row>
        <Row>
          <Button
            label={anotherGuestLabel}
            onClick={handleRegisterAnotherGuest}
            className="link"
            secondary
          />
        </Row>
      </ModalBody>
    </StyledModalGuestRegistered>
  );
}

export {ModalGuestRegistered};
